import {
  MDSPlanCard,
  MDSPlanCardSlot,
  MDSPlanCardBackground,
  MDSPlanCardBorder,
  MDSPlanId,
  MDSButton,
  MDSButtonVariant,
  MDSBadge,
  MDSBadgeVariant,
  MDSText,
  MDSTextVariant,
  MDSTextWeight,
} from "@/mds";
import { proFeatures } from "@/pages/settings/components/subscription-management/data";
import { CardsRow, TitleAndBadgeContainer } from "./subscription.styles";

interface Props {
  onManageProPlan: () => void;
}

export const SubscribedPlanManagement: React.FC<Props> = ({ onManageProPlan }) => {
  return (
    <>
      <TitleAndBadgeContainer>
        <MDSText variant={MDSTextVariant.HeaderL}>Pro Plan</MDSText>
        <MDSBadge label="Best for your usage" variant={MDSBadgeVariant.Emphasis} />
      </TitleAndBadgeContainer>
      <CardsRow>
        <MDSText>Unlimited usage</MDSText>
        <MDSPlanCard
          plan={MDSPlanId.Paid}
          features={proFeatures}
          border={MDSPlanCardBorder.Emphasis}
          background={MDSPlanCardBackground.Emphasis}
        >
          <MDSText
            variant={MDSTextVariant.HeaderL}
            weight={MDSTextWeight.SemiBold}
            slot={MDSPlanCardSlot.Title}
          >
            Pro
          </MDSText>
          <MDSBadge
            label="Unlimited"
            variant={MDSBadgeVariant.MoreEmphasis}
            slot={MDSPlanCardSlot.TitleBadge}
          />
          <div slot={MDSPlanCardSlot.Price}>$12 / month</div>
          <MDSButton
            variant={MDSButtonVariant.Emphasis}
            onClick={onManageProPlan}
            slot={MDSPlanCardSlot.Footer}
          >
            Manage Pro Plan
          </MDSButton>
        </MDSPlanCard>
      </CardsRow>
    </>
  );
};
